import { CreateElement } from "vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import ResourceItemHyperlink from "./ResourceItemHyperlink";
import { ResourceIdentifier } from "@megarax/client/src/resources/Resource";

@Component({})
export default class ResourceItemReference extends Vue {
  @Prop({ required: true })
  resource!: ResourceIdentifier | string;

  get resolvedResource() {
    if (typeof this.resource == "string") {
      const [appLabel, name] = this.resource.split(".");
      return { appLabel, name } as ResourceIdentifier;
    } else return this.resource;
  }

  @Prop()
  value!: ResourceItem | ResourceItem[];

  render(h: CreateElement) {
    if (!this.value) return h("span", "-");
    if (Array.isArray(this.value)) {
      if (!this.value.length) return h("span", "-");
      return h(
        "div",
        this.value.map((i) => this.renderLink(h, i)),
      );
    } else return this.renderLink(h, this.value);
  }

  renderLink(h: CreateElement, item: ResourceItem) {
    return h(
      ResourceItemHyperlink,
      {
        props: { resource: this.resolvedResource, itemId: item.id },
      },
      this.$slots.default
        ? this.$slots.default
        : `[${item.str || item.toString()}] `,
    );
  }
}
